import { render, staticRenderFns } from "./discussion_actions.vue?vue&type=template&id=5d30ac98"
import script from "./discussion_actions.vue?vue&type=script&lang=js"
export * from "./discussion_actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports